import { EMediaType } from '../../components/Carousel/interfaces';
import { IState } from '../../store';
import { getVideos } from '../../utils/gallery_helpers';

export function getCarouselVideos(state: IState) {
  return getVideos(state).map(({ url = '' }) => ({
    mediaType: EMediaType.Video,
    videoUrl: url,
  }));
}
